export default __webpack_public_path__ + "static/media/pkomorabl.bc70c146.png";